import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

export class Freshchat extends React.Component {

  static propTypes = {
    userId: PropTypes.string,
    firstName: PropTypes.string,
    email: PropTypes.string
  }

  componentWillReceiveProps = (nextProps) => {
    if (!window.fcWidget) {
      return;
    }

    if (this.userId !== nextProps.userId && nextProps.email) {
      window.fcWidget.setExternalId('userId:' + nextProps.userId);
      window.fcWidget.user.setFirstName(nextProps.firstName);
      window.fcWidget.user.setEmail(nextProps.email);
    }
  }

  render = () => false
}

function mapStateToProps (state) {
  return {
    userId: state.user.id,
    firstName: state.user.firstName,
    email: state.user.email
  };
};

export default connect(mapStateToProps)(Freshchat);



/** WEBPACK FOOTER **
 ** ./src/components/utils/freshchat.js
 **/